exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-form-label[data-v-54b149d4] {\n    white-space: nowrap;\n}\n.uploading-image[data-v-54b149d4] {\n    display: -webkit-box;\n    display: flex;\n}\n.custom-danger[data-v-54b149d4] {\n    text-align: center;\n    margin-left: 0px !important;\n    padding: 4px;\n}\n", ""]);

// exports
